module.exports = __webpack_public_path__ + "img/payment_success.75d526f5.svg";